import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {NextChevronIcon, PreviousChevronIcon} from 'components/Icon';
import {
  BookingStep,
  getNextStep,
  getPreviousStep,
  getStepURL,
  stepIsAccessible
} from '../../steps';
import {Booking, BookingSettings, DraftBooking} from 'services/entities/booking';
import './index.scss';
import {loadSettings} from 'services/pricing';

interface BookingBannerProps {
  title: string;
  subtitle: string;
  currentStep: BookingStep;
  booking: DraftBooking|Booking|null;
}

interface BookingBannerState {
  bookingSettings: BookingSettings|null;
}

export default class BookingBanner extends Component<BookingBannerProps, BookingBannerState> {
  state = {
    bookingSettings: null
  };

  componentDidMount(): void {
    loadSettings().then(
      settings => this.setState({bookingSettings: settings})
    );
  }

  getStepClass(step: BookingStep, enabled: boolean): string {
    let className = '';
    if(step === this.props.currentStep) {
      className += ' current';
    }
    if(!enabled) {
      className += ' disabled';
    }
    return className;
  }

  stepIsAccessible(step: BookingStep): boolean {
    if(!this.state.bookingSettings || !this.props.booking) {
      return false;
    }
    return stepIsAccessible(step, this.props.booking, this.state.bookingSettings!);
  }

  renderStep(step: BookingStep, label: string, num: number) {
    const enabled = !!this.props.booking && this.stepIsAccessible(step);
    const url = getStepURL(step, this.props.booking ? this.props.booking.code : null);
    return <li className={this.getStepClass(step, enabled)}>
      { enabled
        ? <Link to={url}> <span className="number">{num}</span>{label}</Link>
        : <span><span className="number">{num}</span>{label}</span>
      }
    </li>;
  }

  render() {
    const booking = this.props.booking;
    const settings = this.state.bookingSettings;
    let prevStep = booking && settings ? getPreviousStep(this.props.currentStep, booking, settings) : null;
    let nextStep = booking && settings ? getNextStep(this.props.currentStep, booking, settings) : null;
    return <div className="booking-banner">
      <ul className="nav">
        { this.renderStep(BookingStep.Time, 'Date & Time', 1) }
        { this.renderStep(BookingStep.CheckOut, 'Details', 2) }
      </ul>
      <div className="title">
        { prevStep !== null
          ? <Link className="previous" to={getStepURL(prevStep, booking!.code)}><PreviousChevronIcon/></Link>
          : <span className="previous"><PreviousChevronIcon/></span> }
        <h1>{ this.props.title }</h1>
        <div className="subtitle">{ this.props.subtitle }</div>
        { nextStep !== null
          ? <Link className="next" to={getStepURL(nextStep, booking!.code)}><NextChevronIcon/></Link>
          : <span className="next"><NextChevronIcon/></span> }
      </div>
    </div>;
  }
}